import React, { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import { IMAGES } from "../constants/image";
import { ENDPOINTS } from "../services/endpoints";
import Select, { SingleValue, OnChangeValue } from "react-select";
import { FaDownload } from "react-icons/fa";

const DownloadIcon = FaDownload as React.ComponentType<{
  "aria-hidden"?: boolean;
}>;
interface Option {
  value: string | number;
  label: string;
}
interface CancerApiResponse {
  cancer_master_id: number;
  icc_code: string;
  icc3_code: string;
  cancer_code: string;
  cancer_name: string;
}
interface Stage {
  level: number;
  columns: string[];
}
interface DistrictApiResponse {
  district_master_id: number;
  district_code: string;
  district_name: string;
}
const defaultStages: Stage[] = [
  {
    level: 1,
    columns: [],
  },
  {
    level: 2,
    columns: [],
  },
];
interface FilterPayload {
  display_type: string | null;
  district: "all" | number[];
  icc_code: string;
  icc3_code: string;
  stages: Stage[];
}

const Factsheets = () => {
  const displayOptions: Option[] = [
    { label: "Population", value: "population" },
    { label: "Cancer", value: "cancer" },
  ];
  const [selectedDisplay, setSelectedDisplay] = useState<Option | null>(
    displayOptions[0],
  );
  const [districtOptions, setDistrictOptions] = useState<Option[]>([]);
  const [selectedDistricts, setSelectedDistricts] = useState<Option | null>(
    null,
  );

  const [cancerTypeOptions, setCancerTypeOptions] = useState<Option[]>([]);
  const [selectedCancersType, setSelectedCancersType] = useState<Option[]>([]);

  const [subCancerTypeOptions, setSubCancerTypeOptions] = useState<Option[]>(
    [],
  );
  const [selectedSub_CancersType, setSelectedSub_CancersType] = useState<
    Option[]
  >([]);
  const [stageOptions, setStageOptions] = useState<Option[]>([]);
  const [selectedStages, setSelectedStages] = useState<Option[]>([]);
  const [selectedStageColumns, setSelectedStageColumns] = useState<
    Record<number, Option[]>
  >({});
  // const [columnOptions, setColumnOptions] = useState<Option[]>([]);
  // const [selectedColumns, setSelectedColumns] = useState<Option[]>([]);
  const [stageData, setStageData] = useState<any[]>([]);
  const ICON_MAP: Record<string, string> = {
    factsheet: IMAGES.FACTSHEET.FACTSHEET,
  };
  const isCancer = selectedDisplay?.value === "cancer";
  const isPopulation = selectedDisplay?.value === "population";
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadMessage, setDownloadMessage] = useState<string | null>(null);
  const [filterPayload, setFilterPayload] = useState<FilterPayload>({
    display_type: "population",
    district: "all",
    icc_code: "all",
    icc3_code: "all",
    stages: defaultStages,
  });
  // ---------------- DISPLAY ----------------

  const handleDisplayChange = (selectedOption: SingleValue<Option>) => {
    setSelectedDisplay(selectedOption);

    setFilterPayload((previousPayload) => ({
      ...previousPayload,
      display_type: selectedOption?.value?.toString() || null,
    }));
  };
  // ---------------- DISTRICT ----------------
  const handleDistrictChange = (selectedOption: SingleValue<Option>) => {
    setSelectedDistricts(selectedOption);

    setFilterPayload((previousPayload) => ({
      ...previousPayload,
      district: selectedOption ? [Number(selectedOption.value)] : "all",
    }));
  };
  // ---------------- CANCER TYPE ----------------

  const handleCancerTypeChange = (
    selectedOptions: OnChangeValue<Option, true>,
  ) => {
    const selectedCancerOptions = selectedOptions ? [...selectedOptions] : [];

    setSelectedCancersType(selectedCancerOptions);

    const iccCode = selectedCancerOptions
      .map((option) => option.value)
      .join(",");

    setFilterPayload((previousPayload) => ({
      ...previousPayload,
      icc_code: iccCode || "all",
      icc3_code: "all",
    }));

    // Reset sub cancer selection
    setSelectedSub_CancersType([]);

    if (iccCode && iccCode !== "all") {
      fetchSubCancerTypeOptions(iccCode);
    } else {
      setSubCancerTypeOptions([]);
    }
  };

  // ---------------- SUB CANCER TYPE ----------------

  const handleSubCancerTypeChange = (
    selectedOptions: OnChangeValue<Option, true>,
  ) => {
    const selectedOptionsArray = selectedOptions ? [...selectedOptions] : [];

    setSelectedSub_CancersType(selectedOptionsArray);

    const selectedValues = selectedOptionsArray.map((option) => option.value);

    setFilterPayload((previousPayload) => ({
      ...previousPayload,
      icc3_code: selectedValues.length > 0 ? selectedValues.join(",") : "all",
    }));
  };

  // ---------------- FETCH SUB CANCER TYPES ----------------

  const fetchSubCancerTypeOptions = async (iccCode: string) => {
    try {
      const response = await api.post(
        ENDPOINTS.FACTSHEETS.SELECTED_CANCER_TYPE,
        {
          selected_icc_code: iccCode.split(",").map((code) => String(code)),
        },
      );

      const subCancerData = response.data?.icc3_code_list || [];

      const subCancerOpts: Option[] = subCancerData
        .filter((item: any) => item.icc3_code)
        .map((item: any) => ({
          value: item.icc3_code,
          label: `${item.icc3_code} - ${item.cancer_name}`,
        }));

      setSubCancerTypeOptions(subCancerOpts);
    } catch (error) {
      console.error("Error fetching sub-cancer types:", error);

      setSubCancerTypeOptions([]);
    }
  };
  // ---------------- STAGING  ----------------
  // const handleStageChange = (selectedOption: SingleValue<Option>) => {
  //   setSelectedStages(selectedOption);
  //   setSelectedColumns([]);

  //   const selectedLevel = stageData.find(
  //     (stage) => stage.level === Number(selectedOption?.value),
  //   );

  //   if (selectedLevel) {
  //     setColumnOptions(
  //       selectedLevel.columns.map((col: string) => ({
  //         value: col,
  //         label: col,
  //       })),
  //     );
  //   } else {
  //     setColumnOptions([]);
  //   }

  //   // Reset payload columns when stage changes
  //   setFilterPayload((prev) => ({
  //     ...prev,
  //     stages: prev.stages.map((stage) => ({
  //       ...stage,
  //       columns: [],
  //     })),
  //   }));
  // };
  //implemented staging subtype dynamically
  // const handleStageChange = (selectedOptions: OnChangeValue<Option, true>) => {
  //   const stages = selectedOptions ? [...selectedOptions] : [];

  //   setSelectedStages(stages);

  //   // Remove deselected stages
  //   const selectedLevels = stages.map((stage) => Number(stage.value));

  //   setSelectedStageColumns((prev) =>
  //     Object.fromEntries(
  //       Object.entries(prev).filter(([level]) =>
  //         selectedLevels.includes(Number(level)),
  //       ),
  //     ),
  //   );
  // };
  const handleStageChange = (selectedOptions: OnChangeValue<Option, true>) => {
    const stages = selectedOptions ? [...selectedOptions] : [];

    setSelectedStages(stages);

    const selectedLevels = stages.map((stage) => Number(stage.value));

    const updatedStageColumns = Object.fromEntries(
      Object.entries(selectedStageColumns).filter(([level]) =>
        selectedLevels.includes(Number(level)),
      ),
    );

    setSelectedStageColumns(updatedStageColumns);

    setFilterPayload((prev) => ({
      ...prev,
      stages:
        stages.length === 0
          ? defaultStages
          : stages.map((stage) => ({
              level: Number(stage.value),
              columns:
                updatedStageColumns[Number(stage.value)]?.map(
                  (option) => option.value as string,
                ) || [],
            })),
    }));
  };
  // ---------------- DYNAMIC LABEL-----------------
  const getStageLabel = (level: number) => {
    switch (level) {
      case 1:
        return "Toronto Tier1 Stage";
      case 2:
        return "Toronto Tier2 Stage";
      default:
        return `Toronto Tier ${level} Stage`;
    }
  };
  // const handleColumnChange = (selectedOptions: OnChangeValue<Option, true>) => {
  //   const selectedColumnsArray = selectedOptions ? [...selectedOptions] : [];

  //   setSelectedColumns(selectedColumnsArray);

  //   const columns = selectedColumnsArray.map(
  //     (option) => option.value as string,
  //   );

  //   const level = Number(selectedStages?.value);

  //   setFilterPayload((prev) => ({
  //     ...prev,
  //     stages: [
  //       {
  //         level,
  //         columns,
  //       },
  //     ],
  //   }));
  // };
  //implemented stage columns
  // const handleStageColumnsChange = (
  //   level: number,
  //   selectedOptions: OnChangeValue<Option, true>,
  // ) => {
  //   const columns = selectedOptions ? [...selectedOptions] : [];

  //   setSelectedStageColumns((prev) => ({
  //     ...prev,
  //     [level]: columns,
  //   }));

  //   setFilterPayload((prev) => ({
  //     ...prev,
  //     stages: Object.entries({
  //       ...selectedStageColumns,
  //       [level]: columns,
  //     }).map(([lvl, options]) => ({
  //       level: Number(lvl),
  //       columns: options.map((option) => option.value as string),
  //     })),
  //   }));
  // };
  const handleStageColumnsChange = (
    level: number,
    selectedOptions: OnChangeValue<Option, true>,
  ) => {
    const columns = selectedOptions ? [...selectedOptions] : [];

    setSelectedStageColumns((prev) => {
      const updated = {
        ...prev,
        [level]: columns,
      };

      const stagesPayload =
        selectedStages.length === 0
          ? defaultStages
          : selectedStages.map((stage) => ({
              level: Number(stage.value),
              columns:
                updated[Number(stage.value)]?.map(
                  (option) => option.value as string,
                ) || [],
            }));

      setFilterPayload((prevPayload) => ({
        ...prevPayload,
        stages: stagesPayload,
      }));

      return updated;
    });
  };
  const fetchFilter = useCallback(async () => {
    try {
      const [cancerResponse, districtResponse] = await Promise.all([
        api.get(ENDPOINTS.FACTSHEETS.CANCER_LIST),
        api.get(ENDPOINTS.FACTSHEETS.DISTRICT_LIST),
      ]);

      // ---------------- CANCER LIST ----------------

      const allCancer: CancerApiResponse[] =
        cancerResponse.data.cancer_list || [];
      //Stages from response
      const stages = cancerResponse.data.stages || [];
      setStageData(stages);

      // UNIQUE ICC CODE LIST
      //old
      // const uniqueCancerTypes = Array.from(
      //   new Map(
      //     allCancer.map((item) => [
      //       item.icc_code,
      //       {
      //         value: item.icc_code,
      //         label: `${item.icc_code} - ${item.cancer_name}`,
      //       },
      //     ]),
      //   ).values(),
      // );
      const uniqueCancerTypes = allCancer
        .filter((item) => item.icc_code === item.cancer_code)
        .map((item) => ({
          value: item.icc_code,
          label: `${item.icc_code} - ${item.cancer_name}`,
        }));
      setCancerTypeOptions(uniqueCancerTypes);

      // RESET SUB CANCER
      setSubCancerTypeOptions([]);

      // ---------------- DISTRICT LIST ----------------

      const allDistricts: DistrictApiResponse[] = districtResponse.data || [];

      const districtOpts = allDistricts.map((item: DistrictApiResponse) => ({
        value: item.district_master_id,
        label: item.district_name,
      }));

      setDistrictOptions(districtOpts);

      // ---------------- DEFAULT VALUES ----------------

      setSelectedDisplay({
        value: "population",
        label: "Population",
      });

      //------------------Stage Options-------------------
      const stageOpts = stages.map((item: any) => ({
        value: item.level,
        label: `Toronto Tier ${item.level}`,
      }));
      setSelectedDistricts(null);

      setSelectedCancersType([]);

      setSelectedSub_CancersType([]);

      setStageOptions(stageOpts);
    } catch (error) {
      console.error("Error fetching filters:", error);
    }
  }, []);

  useEffect(() => {
    fetchFilter();
  }, [fetchFilter]);

  // ---------------- FETCH FACTSHEET ----------------

  const sanitizeFilenamePart = (value: string) =>
    value
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-zA-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "") || "All";

  const getFactsheetFilename = () => {
    const districtName = selectedDistricts?.label || "All_Districts";
    const selectedCancerLabels =
      selectedSub_CancersType.length > 0
        ? selectedSub_CancersType.map((item) => item.label)
        : selectedCancersType.map((item) => item.label);
    const cancerName =
      selectedCancerLabels.length > 0
        ? selectedCancerLabels.join("_")
        : "All_Cancers";
    const displayName = selectedDisplay?.label || "Population";

    return `Factsheet_${sanitizeFilenamePart(districtName)}_${sanitizeFilenamePart(
      cancerName,
    )}_${sanitizeFilenamePart(displayName)}.pdf`;
  };

  const fetchFactsheetData = async () => {
    setIsDownloading(true);
    setDownloadMessage(null);

    try {
      const response = await api.post(
        ENDPOINTS.FACTSHEETS.FACTSHEET,
        filterPayload,
        {
          responseType: "blob",
        },
      );
      // CREATE PDF BLOB
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      // CREATE DOWNLOAD LINK
      const link = document.createElement("a");

      link.href = url;

      link.download = getFactsheetFilename();

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error fetching factsheet data:", error);
      setDownloadMessage("Unable to generate the factsheet. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  // ---------------- INITIAL API CALLS ----------------

  return (
    <section className="factsheets-page">
      <div className="factsheets-inner">
        <div className="factsheet-preview-panel">
          <div className="factsheet-card">
            <div className="factsheet-report-heading">
              <div>
                <img
                  src={ICON_MAP["factsheet"]}
                  alt="Factsheet_chart"
                  className="factsheet-image"
                />
                {/* <div className="factsheet-controls-heading">
                  <h2>Factsheet</h2>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="factsheet-filter-wrapper">
          <div className="factsheet-controls-card">
            <div className="factsheet-filter-title">
              <p>Factsheet</p>
            </div>
            <form>
              <div className="mb-1">
                <label className="text-white">Display</label>
                <Select<Option, false>
                  aria-label="Display"
                  closeMenuOnSelect={true}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Display"
                  options={displayOptions}
                  value={selectedDisplay}
                  onChange={handleDisplayChange}
                />
                {isPopulation && (
                  <>
                    <label className="text-white">District</label>
                    <Select<Option, false>
                      aria-label="District"
                      closeMenuOnSelect={true}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Districts"
                      options={districtOptions}
                      value={selectedDistricts}
                      onChange={handleDistrictChange}
                    />
                  </>
                )}
                {isCancer && (
                  <>
                    <label className="text-white">Cancer Type</label>
                    <Select<Option, true>
                      isMulti
                      aria-label="Display"
                      closeMenuOnSelect={true}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Cancer Type"
                      options={cancerTypeOptions}
                      value={selectedCancersType}
                      onChange={handleCancerTypeChange}
                    />
                    <label className="text-white">Cancer Sub type</label>
                    <Select<Option, true>
                      isMulti
                      aria-label="Cancer Sub type"
                      closeMenuOnSelect={true}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Cancer Sub Type"
                      options={subCancerTypeOptions}
                      value={selectedSub_CancersType}
                      onChange={handleSubCancerTypeChange}
                    />
                    <label className="text-white">Staging Type</label>
                    <Select<Option, true>
                      isMulti
                      aria-label="Staging Type"
                      closeMenuOnSelect={true}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Staging Type"
                      options={stageOptions}
                      value={selectedStages}
                      onChange={handleStageChange}
                    />
                    {selectedStages.length > 0 &&
                      selectedStages.map((stage) => {
                        const level = Number(stage.value);

                        const stageInfo = stageData.find(
                          (item) => item.level === level,
                        );

                        const options =
                          stageInfo?.columns.map((col: string) => ({
                            value: col,
                            label: col,
                          })) || [];

                        return (
                          <div key={level}>
                            <label className="text-white">
                              {getStageLabel(level)}
                            </label>

                            <Select<Option, true>
                              isMulti
                              aria-label="Staging Sub Type"
                              closeMenuOnSelect={true}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder={getStageLabel(level)}
                              options={options}
                              value={selectedStageColumns[level] || []}
                              onChange={(selectedOptions) =>
                                handleStageColumnsChange(level, selectedOptions)
                              }
                            />
                          </div>
                        );
                      })}
                  </>
                )}
              </div>
              <div className="factsheet-download-btn">
                <button
                  type="button"
                  className="factsheet-action-btn"
                  disabled={isDownloading}
                  onClick={fetchFactsheetData}
                  aria-label="Download factsheet"
                >
                  <span>Download Factsheet</span>
                  <DownloadIcon aria-hidden />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {isDownloading ? (
        <div
          className="factsheet-loading-overlay"
          role="alert"
          aria-live="assertive"
        >
          <div className="factsheet-loading-dialog">
            <div className="factsheet-loading-spinner" aria-hidden="true" />
            <h2>Generating factsheet</h2>
            <p>
              Please wait while the PDF is prepared. The download will start
              automatically.
            </p>
          </div>
        </div>
      ) : null}
      {downloadMessage ? (
        <div
          className="factsheet-loading-overlay"
          role="alert"
          aria-live="assertive"
        >
          <div className="factsheet-loading-dialog">
            <h2>Download failed</h2>
            <p>{downloadMessage}</p>
            <button type="button" onClick={() => setDownloadMessage(null)}>
              OK
            </button>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default Factsheets;
